import { useEffect, useState } from 'react';
import { useLDClient, useFlags } from 'launchdarkly-react-client-sdk';

import { tracker } from '..';
import { watchedFlags, AnalyticsFeatureFlags } from '../constants/feature-flags';

export type { AnalyticsFeatureFlags } from '../constants/feature-flags';
export { watchedFlags } from '../constants/feature-flags';

export function useFeatureFlagsMonitor(waitForTrigger: boolean): boolean {
  const flags = useFlags();
  const client = useLDClient();
  const [loading, setLoading] = useState(true);
  const [value, rerender] = useState(true);
  const hasDispensaryContext = client ? client.getContext()['ecomm-dispensary'] : false;

  useEffect(() => {
    if (!client || !loading) {
      return undefined;
    }
    // waiting for client.identify
    if (hasDispensaryContext) {
      setLoading(false);
      return undefined;
    }
    // we don't get automatically re-rendered when context changes
    // so we should schedule one for later in case there's a race condition
    const timerId = setTimeout(() => {
      rerender(!value);
    }, 1000);
    return () => {
      clearTimeout(timerId);
    };
  }, [client, flags, loading, value, hasDispensaryContext]); // run this block for checking hasDispensaryContext and changing loading

  useEffect(() => {
    if (!waitForTrigger && !loading) {
      const featureFlags = Object.fromEntries(
        Object.entries(watchedFlags).map(([name, defaultValue]) => [name, flags[name] ?? defaultValue])
      ) as AnalyticsFeatureFlags;

      tracker.setContext({ featureFlags });
    }
  }, [waitForTrigger, loading, flags]);

  return loading;
}
